export const GET_AGGREGATED_QUERIES_TIMESERIES =
    'getAggregatedQueriesTimeseries';
export const GET_QUERIES_TIMESERIES = 'getQueriesTimeseries';
